import { createReducer } from 'redux-starter-kit';
import { handleError } from '../../modules/utils/handleError';
import { translation } from '../../_helpers/Translate';
import { AccountSettingsApi } from './AccountSettingsApi';
import Notice from '../../modules/utils/Notice';
import { setUserRequester } from '../LoginPage/LoginDucks';
import i18next from 'i18next';

const initialState = {
  meta: null,
  loading: false,
  loadingSave: false,
  person: null,
  account: null,
  loadingMyChildData: false,
  myChildData: []
};

export const accountSettingsModule = 'accountSettings';
const LOADING = `${accountSettingsModule}/LOADING`;
const SET_DATA = `${accountSettingsModule}/SET_DATA`;
const LOADING_SAVE = `${accountSettingsModule}/LOADING_SAVE`;
const CLEAR_STATE = `${accountSettingsModule}/CLEAR_STATE`;
const SET_PERSON = `${accountSettingsModule}/SET_PERSON`;
const SET_ACCOUNT = `${accountSettingsModule}/SET_ACCOUNT`;
const LOADING_MY_CHILD_DATA = `${accountSettingsModule}/LOADING_MY_CHILD_DATA`;
const SET_MY_CHILD_DATA = `${accountSettingsModule}/SET_MY_CHILD_DATA`;

export default createReducer(initialState, {
  [LOADING]: (state, action) => {
    state.loading = action.loading;
  },
  [SET_DATA]: (state, action) => {
    if (action.meta) {
      state.meta = action.meta;
    }
    state.data = action.data;
  },
  [LOADING_SAVE]: (state, action) => {
    state.loadingSave = action.loading;
  },
  [SET_PERSON]: (state, action) => {
    state.person = action.payload;
  },
  [SET_ACCOUNT]: (state, action) => {
    state.account = action.payload;
  },
  [LOADING_MY_CHILD_DATA]: (state, action) => {
    state.loadingMyChildData = action.loading;
  },
  [SET_MY_CHILD_DATA]: (state, action) => {
    state.myChildData = action.data;
  },
  [CLEAR_STATE]: () => initialState
});

export const clearState = () => ({ type: CLEAR_STATE });

export const loadRequesterMeta = () => async dispatch => {
  try {
    dispatch({ type: LOADING, loading: true });
    const { data: metadata } = await AccountSettingsApi.loadRequesterMeta();

    dispatch({ type: SET_DATA, meta: metadata });
  } catch (e) {
    handleError(e, translation('accountSettingsDucks_loadRequesterFailed'));
  } finally {
    dispatch({ type: LOADING, loading: false });
  }
};

export const saveRequesterData = (formData, callback) => async dispatch => {
  try {
    dispatch({ type: LOADING_SAVE, loading: true });
    const response = await AccountSettingsApi.updateRequesterData(formData);
    if (response.data.results.length === 0) {
      dispatch({ type: SET_DATA, data: response.data.entity });
      await dispatch(setUserRequester());
      callback();
      Notice.success(translation('accountSettingsDucks_saveRequesterSuccess'));
      localStorage.removeItem('isFirstAuth');
      if (localStorage.getItem('user')) {
        localStorage.removeItem('user');
      }
    } else {
      handleError(response, translation('accountSettingsDucks_saveRequesterFailed'));
    }
  } catch (e) {
    handleError(e, translation('accountSettingsDucks_saveRequesterFailed'));
  } finally {
    dispatch({ type: LOADING_SAVE, loading: false });
  }
};

export const getPerson = (iin, username, isFirstAuth) => async dispatch => {
  try {
    dispatch({ type: LOADING_SAVE, loading: true });
    const data = await AccountSettingsApi.getPerson(iin);
    if (!isFirstAuth) {
      const userProfile = await AccountSettingsApi.getUserProfile(username);
      if (userProfile.data.result) {
        dispatch({ type: SET_ACCOUNT, payload: userProfile.data.result });
      }
    }

    if (data.status === 200) {
      let user = null;
      data.data.content.forEach(item => {
        let obj = {};
        item.passportValues.forEach(a => {
          obj[a.code] = a.value;
        });
        user = obj;
      });
      dispatch({ type: SET_PERSON, payload: user });
    }
  } catch (e) {
    handleError(e, translation('accountSettingsDucks_loadRequesterFailed'));
  } finally {
    dispatch({ type: LOADING_SAVE, loading: false });
  }
};

export const loadMyChildrenList = () => async dispatch => {
  dispatch({ type: LOADING_MY_CHILD_DATA, loading: true });
  try {
    const { data } = await AccountSettingsApi.getMyChildrenListFromIntegration();
    if (Array.isArray(data?.result) && data.result.length > 0) {
      dispatch({
        type: SET_MY_CHILD_DATA,
        data: data.result
      });
    } else {
      Notice.info(i18next.t('myReports_noData'));
    }
  } catch (error) {
    handleError(error, i18next.t('myReports_errorLoad'));
    throw error;
  } finally {
    dispatch({ type: LOADING_MY_CHILD_DATA, loading: false });
  }
};
